<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addCoachDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
    append-to-body
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item required prop="coachName" label="教练姓名:">
          <el-input type="text" v-model="form.coachName"></el-input>
        </el-form-item>
        <el-form-item prop="isShow" label="是否显示在小程序:">
          <el-select v-model="form.isShow" placeholder="是否显示在小程序">
            <el-option
              v-for="item in isShowType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教练头像">
          <el-upload
            action="/api/manager/file/uploadPhotos"
            :data="pictureType"
            :file-list="fileList"
            :limit="1"
            :on-exceed="handleExceed"
            name="picture"
            list-type="picture-card"
            :on-preview="handleAvatarPictureCardPreview"
            :on-remove="handleAvatarRemove"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog
            :visible.sync="avatarDialogVisible"
            size="tiny"
            append-to-body
          >
            <img width="100%" :src="dialogAvatarImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="教练详情">
          <el-upload
            action="/api/manager/file/uploadPhotos"
            :data="pictureType1"
            :file-list="detailImgList"
            :limit="1"
            :on-exceed="handleExceed"
            name="picture"
            list-type="picture-card"
            :on-preview="handleDetailsPictureCardPreview"
            :on-remove="handleDetailsRemove"
            :on-success="handleDetailsSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog
            :visible.sync="detailsDialogVisible"
            size="tiny"
            append-to-body
          >
            <img width="100%" :src="dialogDetailsImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { addCoach, editCoach, deleteImage } from "@/api/coach";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  name: "addFundDialogs",
  data() {
    let validateData = (rule, value, callback) => {};
    return {
      isVisible: this.isShow,
      dialogAvatarImageUrl: "",
      dialogDetailsImageUrl: "",
      avatarDialogVisible: false,
      detailsDialogVisible: false,
      fileList: [],
      detailImgList: [],
      isShowType: [
        { label: "否", value: 0 },
        { label: "是", value: 1 },
      ],
      form: {
        coachId: "",
        coachName: "",
        coachAvator: "",
        coachDetailsImage: "",
        isShow: "",
      },
      pictureType: {
        pictureType: "avator",
      },
      pictureType1: {
        pictureType: "details",
      },
      form_rules: {},
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
  },
  computed: {
    ...mapGetters(["addCoachDialog"]),
  },
  created() {},
  mounted() {
    if (this.addCoachDialog.type === "edit") {
      this.form = this.dialogRow;
      //更新图片列表
      console.log("教练头像:" + this.form.coachAvator);
      if (this.form.coachAvator !== "" && this.form.coachAvator !== null) {
        let fileList = [
          {
            name: "",
            url: this.form.coachAvator,
          },
        ];
        this.fileList = fileList;
        this.dialogAvatarImageUrl = this.form.coachAvator;
      }
      console.log("教练详情:" + this.form.coachDetailsImage);
      if (
        this.form.coachDetailsImage !== "" &&
        this.form.coachDetailsImage !== null
      ) {
        let detailsImgList = [
          {
            name: "",
            url: this.form.coachDetailsImage,
          },
        ];
        this.detailImgList = detailsImgList;
        this.dialogDetailsImageUrl = this.form.coachDetailsImage;
      }
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //教练头像图片上传成功回调函数
    handleAvatarSuccess(res, file) {
      console.log(file.response);
      if (file.response.code == 200) {
        this.$message({
          type: "info",
          message: "图片上传成功",
          duration: 3000,
        });
        //更新图片列表
        let fileList = [
          {
            name: "",
            url: file.response.data.url,
          },
        ];
        this.fileList = fileList;
        //更新预览图片的路径
        this.dialogAvatarImageUrl = file.response.data.url;
        this.form.coachAvator = file.response.data.url;
      } else {
        this.$message({
          type: "error",
          message: "图片上传失败",
          duration: 3000,
        });
      }
    },
    // handleAvatarSuccess(res, file) {
    //   console.log(file.response);
    //   if (file.response.code == 200) {
    //     this.$message({
    //       type: "info",
    //       message: "图片上传成功",
    //       duration: 3000
    //     });
    //     //更新图片列表
    //     let fileList = [
    //       {
    //         name: "",
    //         url: file.response.data.avatorImgUrl
    //       }
    //     ];
    //     this.fileList = fileList;
    //     //更新预览图片的路径
    //     this.dialogAvatarImageUrl = file.response.data.avatorImgUrl;
    //     this.form.coachAvator = file.response.data.avatorImgUrl;
    //   }
    // },
    //教练详情图片上传成功的回调函数
    handleDetailsSuccess(res, file) {
      console.log(file.response);
      if (file.response.code == 200) {
        this.$message({
          type: "info",
          message: "图片上传成功",
          duration: 3000,
        });
        //更新图片列表
        let fileList = [
          {
            name: "",
            url: file.response.data.url,
          },
        ];
        this.detailImgList = fileList;
        //更新预览图片的路径
        this.dialogDetailsImageUrl = file.response.data.url;
        this.form.coachDetailsImage = file.response.data.url;
      } else {
        this.$message({
          type: "error",
          message: "图片上传失败",
          duration: 3000,
        });
      }
    },
    // handleDetailsSuccess(res, file) {
    //   this.$message({
    //     type: "info",
    //     message: "图片上传成功",
    //     duration: 6000
    //   });
    //   console.log(file.response);
    //   if (file.response.code == 200) {
    //     //更新图片列表
    //     let fileList = [
    //       {
    //         name: "",
    //         url: file.response.data.detailsImgUrl
    //       }
    //     ];
    //     this.detailImgList = fileList;
    //     //更新预览图片的路径
    //     this.dialogDetailsImageUrl = file.response.data.detailsImgUrl;
    //     this.form.coachDetailsImage = file.response.data.detailsImgUrl;
    //   }
    // },
    //上传图片大于上限的处理函数
    handleExceed() {
      this.$message({
        type: "info",
        message: "只能上传一张图片",
        duration: 6000,
      });
    },
    //删除图片的处理函数
    handleDetailsRemove(file, fileList) {
      let para = {
        url: this.form.coachDetailsImage,
      };
      console.log(para);
      deleteImage(para).then((res) => {
        console.log(res);
        this.form.coachDetailsImage = "";
        this.detailImgList = [];
      });
      this.$message({
        type: "info",
        message: "已删除原有图片",
        duration: 6000,
      });
    },
    //删除图片的处理函数
    handleAvatarRemove(file, fileList) {
      let para = {
        url: this.form.coachAvator,
      };
      console.log(para);
      deleteImage(para).then((res) => {
        console.log(res);
        this.form.coachAvator = "";
        this.fileList = [];
      });
      this.$message({
        type: "info",
        message: "已删除原有图片",
        duration: 6000,
      });
    },
    //图片预览的处理函数
    handleAvatarPictureCardPreview(file) {
      this.avatarDialogVisible = true;
    },
    handleDetailsPictureCardPreview(file) {
      this.detailsDialogVisible = true;
    },
    //上传之前的格式验证函数
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      // const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 4;

      // if (!isJPG) {
      //   console.log("上传头像图片只能是 JPG/PNG 格式!");
      //   this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      // }
      if (!isLt2M) {
        console.log("上传头像图片大小不能超过 4MB!");
        this.$message.error("上传头像图片大小不能超过 4MB!");
      }
      return isLt2M;
      // return (isJPG || isJPG) && isLt2M;
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData);
          console.log(para);
          // edit
          if (this.addCoachDialog.type === "edit") {
            editCoach(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.isVisible = false;
                const para = {
                  userName: getToken("USERNAME"),
                  content: "修改(" + this.form.coachName + ")教练操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$emit("getCoachList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          } else {
            // add
            addCoach(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "新增(" + this.form.coachName + ")教练操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getCoachList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
